import React from 'react'
import OwlCarousel from 'react-owl-carousel'
import 'owl.carousel/dist/assets/owl.carousel.css'
import 'owl.carousel/dist/assets/owl.theme.default.css'

const CardCarousel = ({ children }: any) => {
  return (
    <OwlCarousel
      className="general-owl-theme"
      loop={false}
      margin={0}
      dots
      stagePadding={0}
      autoWidth={false}
      responsive={{
        0: {
          items: 1,
        },
        500: {
          items: 1.1,
        },
        800: {
          items: 1.5,
        },
        1000: {
          items: 2,
        },
      }}
    >
      {children}
    </OwlCarousel>
  )
}

export default CardCarousel
